var map = {
	"./circles.svg": 798,
	"./logo.svg": 799
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 797;


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/Cta ^\.\/.*\.svg$
// module id = 797
// module chunks = 0